import { Button, ClickEvent, Layout, SlideoutDecorator, Snackbar, Toast } from "@mcleod/components";
import { Api, StringUtil } from "@mcleod/core";
import { DeclineDetails } from "./DeclineDetails";
import { RowEdiOrder } from "./models/ModelEdiOrder";
import { CommonDialogs } from "@mcleod/common";

export class DeclineTender {
    private _replyDescr: string = "Problem replying to tender";
    private _ediOrderRow: RowEdiOrder;
    private _declineRequiresCode: string;
    private _success = false;

    async decline() {

        const ediOrderId = this.ediOrderRow.get("id");
        const layout = Layout.getLayout("lme/datafusion/DeclineDetails", {
            height: 1000,
            backgroundColor: "defaultBackground",
            borderColor: "strokeSecondary"
        }) as DeclineDetails;

        layout.version = this.ediOrderRow.get("version");
        layout.partnerId = this.ediOrderRow.get("partner_id");

        if ("Y" == this.ediOrderRow.get("record_in_use")) {
            Snackbar.showSnackbar("Shipment ID: " + this.ediOrderRow.get("shipment_id") + ". This tender is currently locked, and can not be accepted.", { persist: true });
            return;
        }

        if (ediOrderId) {
            const sod = new SlideoutDecorator({
                layout: layout,
                title: "Decline Tender - " + ediOrderId,
                addlComponents: new Button({
                    caption: "Decline",
                    rowBreak: false,
                    onClick: (event: ClickEvent) => {
                        this.processDeclineClick(event.target as Button, sod, this.ediOrderRow, layout);
                    }
                })
            })
        }
    }

    private async processDeclineClick(button: Button, sod: SlideoutDecorator, ediOrderRow: RowEdiOrder, layout: DeclineDetails) {
        const reqReason = this._declineRequiresCode;
        let declineCode: string = "";
        if (reqReason === "Y" && StringUtil.isEmptyString(layout.reasonTextbox.text)) {
            CommonDialogs.showError("A reason code is required by this partner when declining a tender.  Could not send decline.");
            return;
        }
        else if (reqReason === "Y" && layout.reasonTextbox.validate) {
            ediOrderRow.set("reply_reason", layout.reasonTextbox.text);
            declineCode = layout.reasonTextbox.getFirstLookupModelData().get(layout.reasonTextbox.lookupModelResultField, null);
        }
        else {
            if (layout.reasonTextbox.validate && !StringUtil.isEmptyString(layout.reasonTextbox.text)) {
                declineCode = layout.reasonTextbox.getFirstLookupModelData().get(layout.reasonTextbox.lookupModelResultField, null);
            }
            else {
                declineCode = "";
            }
        }
        const ediOrderId = ediOrderRow.get("id");
        const remarks = layout.remarksTextbox.text;
        button.busy = true;

        await this.declineTender(ediOrderId, declineCode, remarks).then(async response => {
            const desc = response?.data[0].description
            const batch = response?.data[0].reply_batch;

            if (!StringUtil.isEmptyString(desc)) {
                this._replyDescr = desc;
            }

            if (batch != "-1" && batch != "0") {
                this._success = true;
            }
        });

        button.busy = false;
        await sod.slideOut();

        if(this._success) {
            Toast.showSuccessToast(this._replyDescr);
        } else {
            Toast.showToast("Unable to transmit reply.  " + this._replyDescr);
        }
    }

    async declineTender(ediOrderId: string, declineCode: string, remarks: string): Promise<any> {
        return await Api.post("lme/datafusion/decline-tender", { edi_order_id: ediOrderId, decline_code: declineCode, decline_remarks: remarks });
    }

    public get success(): boolean {
        return this._success;
    }

    public set success(value: boolean) {
        this._success = value;
    }

    public get replyDescr(): string {
        return this._replyDescr;
    }

    public set replyDescr(value: string) {
        this._replyDescr = value;
    }

    public get ediOrderRow(): RowEdiOrder {
        return this._ediOrderRow;
    }

    public set ediOrderRow(value: RowEdiOrder) {
        this._ediOrderRow = value;
    }

    public get declineRequiresCode(): string {
        return this._declineRequiresCode;
    }

    public set declineRequiresCode(value: string) {
        this._declineRequiresCode = value;
    }
}
